import { FC, useState } from "react";
import Stack from "@mui/material/Stack";
import { Box, LinearProgress } from "@mui/material";
import type { GridApi } from "ag-grid-community";
import {
  ResourceFiltersWithAction,
  ResourceType,
} from "@/services/cloudchipr.api";
import { AutomationsFoundResourcesGrid } from "@/components/pages/automations/common/components/found-resources/components/grid/AutomationsFoundResourcesGrid";
import { AutomationsFoundResourcesGridToolbar } from "@/components/pages/automations/common/components/found-resources/components/toolbar/AutomationsFoundResourcesGridToolbar";
import { useAppSelector } from "@/store/hooks";
import { gridResourceDataLoadingSelector } from "@/store/resources-grid/selectors/resource-data/gridResourceDataLoadingSelector";

interface AutomationsFoundResourcesCardProps {
  accountIds: string[];
  regions: string[];
  singleGrid: boolean;
  gracePeriodEnabled: boolean;
  filters: ResourceFiltersWithAction;
  scheduleAction: string | null;
}

export const AutomationsFoundResourcesCard: FC<
  AutomationsFoundResourcesCardProps
> = ({
  filters,
  accountIds,
  scheduleAction,
  regions,
  gracePeriodEnabled,
  singleGrid,
}) => {
  const [gridApi, setGridApi] = useState<GridApi | null>(null);

  const resourceType = filters.filter.type;
  const masterGridId =
    generateAutomationFoundResourcesMasterGridId(resourceType);

  const loading = useAppSelector((state) =>
    gridResourceDataLoadingSelector(state, masterGridId),
  );

  return (
    <Stack key={resourceType}>
      <AutomationsFoundResourcesGridToolbar
        filters={filters}
        gridApi={gridApi}
        masterGridId={masterGridId}
        scheduleAction={scheduleAction}
        resourceType={resourceType}
      />

      <Box border={1} borderColor="grey.300" borderRadius={2} overflow="hidden">
        {loading && <LinearProgress />}

        <AutomationsFoundResourcesGrid
          regions={regions}
          singleGrid={singleGrid}
          gridApi={gridApi}
          masterGridId={masterGridId}
          gracePeriodEnabled={gracePeriodEnabled}
          setGridApi={setGridApi}
          filter={filters.filter}
          accountIds={accountIds}
        />
      </Box>
    </Stack>
  );
};

export const generateAutomationFoundResourcesMasterGridId = (
  resourceType: ResourceType,
) => `automation-found-${resourceType}-resources-master-grid-id`;
